import { gql } from '@apollo/client';

const GET_UI = gql`
  {
    ui @client {
      isDesktop
      viewStyle
      navigationDrawerOpen
    }
  }
`;

export default GET_UI;
